
import ModalPanel from '@admin/components/modal_panel'
import Img from '@admin/components/html/img'
import PropTypes from 'prop-types'
import React from 'react'

class Complete extends React.PureComponent {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    completed: PropTypes.any,
    title: PropTypes.string,
    onBack: PropTypes.func,
    onClose: PropTypes.func
  }

  _handleClose = this._handleClose.bind(this)

  render() {
    const Completed = this.props.completed
    return (
      <ModalPanel { ...this._getPanel() }>
        <div className="truevail-configure-configuring">
          <div className="truevail-configure-configuring-header">
            <div className="truevail-configure-overview-header-image">
              <Img src="https://assets.mahaplatform.com/imagecache/fit=cover&w=1000&h=250/assets/08dab79852a8a1440b5dd7ea8148b179/halaszbastya.jpg.webp" />
            </div>
          </div>
          <div className="truevail-configure-configuring-body">
            <Completed { ...this._getProps() } />
          </div>
        </div>
      </ModalPanel>
    )
  }

  _getPanel() {
    const { title } = this.props
    return { 
      title,
      rightItems: [
        {
          label: 't(Done)',
          handler: this._handleClose
        }
      ]
    }
  }

  _getProps() {
    const { onBack, onClose } = this.props
    return {
      onBack,
      onClose
    }    
  }

  _handleClose() {
    this.context.modal.close()
  }

}

export default Complete
